module.exports = __webpack_public_path__ + "static/img/qitipBg.664d7ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qitipBg.png
// module id = IQOR
// module chunks = 1